import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const setTranslation = (data) => axios({
  method: 'post',
  url: config.endpoints.translations.translation,
  data,
  headers: getHeaders(true)
})

const removeTranslation = (data) => axios({
  method: 'post',
  url: config.endpoints.translations.remove,
  data,
  headers: getHeaders(true)
})

export default {
  setTranslation,
  removeTranslation
}
